/* Wild Bill's Events Finder: progressive enhancement (cards are server-rendered). */
(function () {
  function init(root) {
    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-wbe-card]'));
    var q = root.querySelector('[data-wbe-q]');
    var chips = Array.prototype.slice.call(root.querySelectorAll('[data-wbe-range]'));
    var countEl = root.querySelector('[data-wbe-count]');
    var empty = root.querySelector('[data-wbe-empty]');
    var tracking = root.getAttribute('data-tracking') === 'true';
    var searchFilterTracking = root.getAttribute('data-search-filter-tracking') === 'true';
    var range = 'all';
    var LIMIT = parseInt(root.getAttribute('data-initial') || '12', 10), expanded = false;
    var more = root.querySelector('[data-wbe-more]');
    var searchTimer = null;

    function track(name, data) {
      if (!tracking) return;
      data = data || {};
      try { window.dataLayer = window.dataLayer || []; window.dataLayer.push(Object.assign({ event: name }, data)); } catch (e) {}
      try { if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') Shopify.analytics.publish(name, data); } catch (e) {}
    }
    function trackSearchFilter(name, data) {
      if (!searchFilterTracking) return;
      track(name, data);
    }
    function pad(n) { return (n < 10 ? '0' : '') + n; }
    function iso(d) { return d.getFullYear() + '-' + pad(d.getMonth() + 1) + '-' + pad(d.getDate()); }
    // "today" in the store's zone (America/New_York) rather than the visitor's clock
    function storeToday() {
      try {
        var p = new Intl.DateTimeFormat('en-CA', { timeZone: 'America/New_York', year: 'numeric', month: '2-digit', day: '2-digit' }).format(new Date());
        if (/^\d{4}-\d{2}-\d{2}$/.test(p)) return p;
      } catch (e) {}
      return iso(new Date());
    }
    function addDays(isoStr, n) { var p = isoStr.split('-'); var d = new Date(+p[0], +p[1] - 1, +p[2] + n); return iso(d); }
    function windowFor(r) {
      var t = storeToday();
      if (r === '30') return [t, addDays(t, 30)];
      if (r === 'weekend') {
        var p = t.split('-'); var dow = new Date(+p[0], +p[1] - 1, +p[2]).getDay(); // 0 Sun..6 Sat
        var toFri = dow === 0 ? 0 : (dow === 6 ? -1 : 5 - dow);
        var fri = addDays(t, toFri), sun = dow === 0 ? t : addDays(fri, 2);
        if (fri < t) fri = t;
        return [fri, sun];
      }
      return [t, '9999-12-31'];
    }
    function norm(s) { return (s || '').toLowerCase().normalize ? (s || '').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '') : (s || '').toLowerCase(); }

    function apply() {
      var w = windowFor(range), terms = norm(q ? q.value : '').split(/[\s,]+/).filter(Boolean), n = 0;
      cards.forEach(function (c) {
        var s = c.getAttribute('data-start'), e = c.getAttribute('data-end');
        var inRange = e >= w[0] && s <= w[1];
        var hay = ' ' + norm(c.getAttribute('data-search')).replace(/[,]/g, ' ') + ' ';
        var match = terms.every(function (t) { return t.length <= 2 ? hay.indexOf(' ' + t + ' ') > -1 : hay.indexOf(t) > -1; });
        var show = inRange && match;
        if (show) n++;
        c.hidden = !show || (!expanded && LIMIT > 0 && n > LIMIT);
      });
      if (more) { more.hidden = expanded || LIMIT <= 0 || n <= LIMIT; more.textContent = 'Show all ' + n + ' events'; }
      if (countEl) countEl.textContent = n === 1 ? '1 upcoming event' : n + ' upcoming events';
      if (empty) empty.hidden = n > 0;
      return n;
    }

    var controls = root.querySelector('[data-wbe-controls]');
    if (controls) controls.hidden = false;
    apply(); // also hides any events that ended since the page was cached

    if (more) more.addEventListener('click', function () {
      expanded = true; var firstHidden = cards.filter(function (c) { return c.hidden; })[0]; apply();
      if (firstHidden && !firstHidden.hidden) { var a = firstHidden.querySelector('a'); if (a) a.focus(); }
    });
    if (q) q.addEventListener('input', function () {
      var n = apply();
      clearTimeout(searchTimer);
      searchTimer = setTimeout(function () { if (q.value.trim()) trackSearchFilter('events_search', { search_term: q.value.trim().slice(0, 100), results_count: n }); }, 800);
    });
    chips.forEach(function (b) {
      b.addEventListener('click', function () {
        range = b.getAttribute('data-wbe-range');
        chips.forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
        var n = apply();
        trackSearchFilter('events_filter', { filter: range, results_count: n });
      });
    });

    root.addEventListener('click', function (ev) {
      var a = ev.target.closest('a'); if (!a || !root.contains(a)) return;
      var card = a.closest('[data-wbe-card]');
      var data = card ? { event_name: card.getAttribute('data-name'), event_start: card.getAttribute('data-start'), event_id: card.id } : {};
      if (a.hasAttribute('data-wbe-scroll')) {
        var f = root.querySelector('#wbe-finder');
        if (f) { ev.preventDefault(); f.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' }); try { f.focus({ preventScroll: true }); } catch (e) {} history.replaceState(null, '', '#wbe-finder'); }
        return;
      }
      if (card) track('event_card_click', Object.assign({ link_type: a.hasAttribute('data-wbe-directions') ? 'directions' : (a.hasAttribute('data-wbe-info') ? 'info' : 'other') }, data));
      if (a.hasAttribute('data-wbe-directions')) track('event_directions_click', data);
      else if (a.hasAttribute('data-wbe-info')) track('event_outbound_click', Object.assign({ url: a.href }, data));
      else if (a.hasAttribute('data-wbe-book')) track('book_event_click', Object.assign({ location: a.closest('.wbe__empty') ? 'empty_state' : 'booking_block', event_name: data.event_name || '', event_start: data.event_start || '' }, data));
    });
  }
  function boot() { Array.prototype.forEach.call(document.querySelectorAll('[data-wbe]'), init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
